import React, { useState, useEffect } from 'react';
import { commentService } from '../utils/commentService';

interface CommentBadgeProps {
  photoId: string;
}

const CommentBadge: React.FC<CommentBadgeProps> = React.memo(({ photoId }) => {
  const [commentCount, setCommentCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCommentCount = async () => {
      try {
        const count = await commentService.getCommentCount(photoId);
        setCommentCount(count);
      } catch (error) {
        console.error('Failed to load comment count:', error);
        setCommentCount(0);
      } finally {
        setLoading(false);
      }
    };

    loadCommentCount();
  }, [photoId]);

  if (loading) {
    return null; // ローディング中は表示しない
  }

  if (commentCount === 0) {
    return null; // コメントがない場合は表示しない
  }

  return (
    <div
      style={{
        backgroundColor: 'var(--accent-mint)',
        color: 'var(--neutral-50)',
        borderRadius: '12px',
        padding: '3px 6px',
        fontSize: '0.65rem',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        boxShadow: 'var(--shadow-sm)',
      }}
    >
      {/* Material Icons: comment */}
      <svg
        width="10"
        height="10"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={{ opacity: 0.9 }}
      >
        <path d="M21.99 4c0-1.1-.89-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.89 2 2 2h14l4 4-.01-18z" />
      </svg>
      <span>{commentCount}</span>
    </div>
  );
});

export default CommentBadge;
